import React, { useState, useContext, useEffect } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import { Context } from '@routes/private/Editor/Context';
import { getCommonValue, getCommonAttributes } from 'utils/multiEditing';
import { storageAccountName, containerName,containerNameBrands } from '@storage/azure-storage-blob';
import ImagePicker from '../../../ImagePicker';
import Button from '@components/Button';
import { IImageAttributes, ISubPickerType } from '@routes/private/Editor/types';
import OptionIcon from '@assets/icons/optionIcon';
import { Left } from '@routes/private/Templates/components/NewTemplate/styles';
import { findElementsByIds } from '@utils/editor';
import attributes from '..';
import { cloneDeep } from 'lodash';
import { getTaggedVisibleElementsId } from '@utils/selectDescribe';

const MultiEditingImageAttribute:React.FC<IProps> = (props) => {
  const urlBrand =`https://${storageAccountName}.blob.core.windows.net/${containerNameBrands}`;  
  const urlFiles = `https://${storageAccountName}.blob.core.windows.net/${containerName}`
  //const [value, setValue] = useState("");
  const [imageAttr, setImageAttr] = useState<IImageAttributes>();
  const [urlImage, setUrlImage] = useState("");
  const [hasChanged, setHasChanged] = useState(0);
  const [open, setOpen] = useState(false);
  const [openPicker, setOpenPicker] = useState(false);  
  const [onHover, setOnHover] = useState(false);  
  let context = useContext(Context);

  useEffect(() => {

    let attributes = cloneDeep(getCommonAttributes(props.elementType,props.selectDescribeFieldId, context.data,context.selectDescribe?.taggedFields));
    if (attributes)
    {        
        setImageAttr(attributes)           
    } 
            
  }, [context.data, props.fieldId]);

 


  const handleOpenGallery = () => {        
    setOnHover(false);    
    if (hasChanged === 4) setHasChanged(2);       
    context.onShowSubPicker(undefined,undefined,[props.selectDescribeFieldId]); 
    setOpenPicker(!openPicker);
  }

  const handleSearchPicker = () =>{              
    setOpenPicker(false);
   if (hasChanged === 4) setHasChanged(2);   

   context.onShowSubPicker(open?undefined:"SearchImages",{category:props.categoryName}, [props.selectDescribeFieldId]);
   setOpen(!open);      
  }



  const getValue = (value:string) => {
    const valueSplit = value.split('/');
    if (valueSplit.length === 1) return `${context.entityInformation.parsedTree}/${valueSplit[0]}.png`
    if (valueSplit.length === 2) return `${valueSplit[0]}/${valueSplit[1]}`
    else return valueSplit[0];
  }

  useEffect(() => {
    if (context.editorStatus.currentSubPicker==undefined)
    {
      setOpen(false);    
      setHasChanged(0)
    }        
    if (context.editorStatus.currentSubPicker!== undefined && hasChanged ===2)
    {
      setOpen(false);
      setHasChanged(0);
    }

  },[context.editorStatus.currentSubPicker])



  useEffect(() => {
    if (context.selectDescribe)
    {
      
      let elementsId = getTaggedVisibleElementsId([props.selectDescribeFieldId], context.selectDescribe?.taggedFields,context.data)
      if (!elementsId.some(r=> context.editorStatus.selectedElementsId.includes(r)))
      { 
        setOpen(false);
        setHasChanged(0);
        
      }
    }

  }, [context.editorStatus.selectedElementsId])

  useEffect(() => {    
      
    setHasChanged(hasChanged + 1);
    if (imageAttr)
    {
      if (imageAttr?.brandId!==undefined)
      {        
        setUrlImage(`${urlBrand}/${imageAttr.brandId}/${imageAttr.brandImageType?.toLowerCase()}/${imageAttr.srcImage}` + "TN");
      }
      else
      {
        if (imageAttr.srcImage?.startsWith("http"))//For images with all path (Ex. chromedata images)
          setUrlImage(imageAttr.srcImage);
        else
          setUrlImage(`${urlFiles}/${getValue(imageAttr.srcImage??"")}`);
      }
    }


  }, [imageAttr]);

  const getBrandData=()=>{
    let strdata =""
    
    if (imageAttr && imageAttr.brandData)
    {
      imageAttr.brandData.map((data:any)=>{
        if (imageAttr.brandImageType ==="BACKGROUNDS" || imageAttr.brandImageType ==="STOCKS")
        {
          strdata+= (strdata!=""?",":"")+ data.value;
        }
        else
        {
          if (data!=="" && data!==undefined)
            strdata+= (strdata!=""?",":"")+ data;
            
        }
      })

    }        
    
    return strdata;
  }

  return (
    <S.FontFamilyContainer>
      {
        !openPicker &&  <Button
        label={open ? hasChanged > 2 ? "OK" : "CANCEL" : "EDIT"}        
        onClick={(e?:any)=>{
          e.stopPropagation();
          handleSearchPicker()
        }}
        style={{
          position: `absolute`,
          right: `-9px`,
          top: `-25px`,
          backgroundColor: `#00000000`,
          hoverBackgroundColor: `#e1e3e9`,
          padding: `8px 9px 8px 9px`,
          boxShadow: `0px 0px 0px 0 rgba(0, 0, 0, 0)`,
        }}
        labelStyle={{
          color: `${C.DARK_BLUE}`,
        }}
      />
     
      }
      { 

        openPicker ?
            <> 
            <Button
            label={openPicker ? hasChanged > 2 ? "OK" : "CANCEL" : "EDIT"}
            onClick={(e?:any)=>{
              e.stopPropagation();
              handleOpenGallery()
            }}
            style={{
              position: `absolute`,
              right: `-9px`,
              top: `-25px`,
              backgroundColor: `#00000000`,
              hoverBackgroundColor: `#e1e3e9`,
              padding: `8px 9px 8px 9px`,
              boxShadow: `0px 0px 0px 0 rgba(0, 0, 0, 0)`,
            }}
            labelStyle={{
              color: `${C.DARK_BLUE}`,
            }}
          />
              <ImagePicker
                multiediting={true}
              />
          </>
        :
        <>
       
          <S.PreviewImage onMouseEnter={()=>setOnHover(true)} onMouseLeave={()=>setOnHover(false)}
            src={urlImage}
          />
          {
            onHover &&
            <>
          <S.ImageOptions onMouseEnter={()=>setOnHover(true)} onMouseLeave={()=>setOnHover(false)} onClick={()=>{handleOpenGallery()}}>            
            <S.TagsContainer>
            {getBrandData()}
            </S.TagsContainer>     
            <S.OptionContainer>                    
            <OptionIcon style={{fillColor: C.WHITE} }     />
            </S.OptionContainer>                         
          </S.ImageOptions>
       
          </>
          }
        </>
      }
    </S.FontFamilyContainer>
  );
}

export default MultiEditingImageAttribute;